import { z } from 'zod';

interface ITCharacteristics {
  label: string;
  id: number | string | null;
}

const TaskCloseCodesSchema: z.ZodSchema<ITCharacteristics> = z.lazy(() =>
  z.object({
    label: z.string(),
    id: z.number().or(z.null()).or(z.string())
  })
);

export const TaskStatusSchema = z.object({
  id: z.number().or(z.string()),
  statusName: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите название статуса' })
    .max(60, { message: 'До 60 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  taskCloseCodes: z.array(TaskCloseCodesSchema),
  availableForImport: z.boolean()
});
